import XEUtils from 'xe-utils';
import httpManager from '../../util/common';
import UserCenterMenu from '@/user_center/components/UserCenterMenu'
import {entityOaid} from '../../util/util';

let user_profile = {
  components: {UserCenterMenu},
  // props: ['oaid'],
  data: () => {
    return {
      account: null,
      valid_period: '2021-02-25至2021-02-25',
      company_name: null,
      first_name: null,
      last_name: null,
      tel: null,
      access_rights: null,
      nameErrMsg: null,
      nameErrMsgShow: false
    }
  },
  mounted () {
    this.getUserProfile()
  },
  methods: {
    inputOnFocus () {
      this.nameErrMsgShow = false
    },
    on_submit (e) {
      let self = this
      if (!self.company_name) {
        if (this.$i18n.locale === 'en') {
          self.nameErrMsg = '*Company Name required'
        } else {
          self.nameErrMsg = '*公司名称不能为空'
        }
        self.nameErrMsgShow = true
        return
      }
      let body = {
        'account': self.account,
        'company_name': self.company_name,
        'first_name': self.first_name,
        'last_name': self.last_name,
        'tel': self.tel
      }
      httpManager('post_user_profile', null, body)
        .then(response => {
          if (!response.data.success) {
            self.valid_period = '2021-02-25至2021-02-25'
            self.company_name = response.data.company_name
            self.first_name = response.data.first_name
            self.last_name = response.data.last_name
            self.tel = response.data.tel
            self.access_rights = response.data.access_rights
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getUserProfile () {
      this.account = sessionStorage.getItem('username')
      let body = {'account': self.account}
      httpManager('get_user_profile', null, body)
        .then(response => {
          if (!response.data.success) {
            self.valid_period = '2021-02-25至2021-02-25'
            self.company_name = response.data.company_name
            self.first_name = response.data.first_name
            self.last_name = response.data.last_name
            self.tel = response.data.tel
            self.access_rights = response.data.access_rights
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
export default user_profile



// WEBPACK FOOTER //
// ./src/user_center/js/user_profile.js